import React from "react";
import { useState } from "react";
import TeamModal from "./teamModal";
import "../styles/theTeam.css"
import CountUp from './CountUp'


const TheTeam: React.FC = () => {

    const [isTeamOpen, setIsTeamOpen] = useState(false);

    const handleOpen = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault(); // Prevent page jump
        setIsTeamOpen(true);
    };

    const handleClose = (): void => {
        setIsTeamOpen(false);
    };

    return (
        <section id="the-team"
            className="w-full min-h-screen flex flex-col justify-center items-center bg-gradient-to-b from-[#0e0e0e] to-[#201647] py-20">

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-light mb-8 text-white">The Team</h2>



            <div className="grid grid-cols-3 grid-rows-6 gap-1 m-4 min-w-full p-32 pt-5 pb-10 min-h-screen">
                <div
                    className="col-start-1 row-start-1 row-span-4 md:col-start-1 md:row-start-1 md:col-span-1 md:row-span-4 bg-gray-300 rounded-md ">
                    <img src="/images/2025.png" alt="Team Member 1" className="w-full h-full  object-cover" />
                </div>
                <div
                    className="col-start-2 row-start-1 row-span-2 md:col-start-2 md:row-start-1 md:col-span-1 md:row-span-2 bg-gray-300 rounded-md ">
                    <img src="/images/car.png" alt="Car" className="w-full h-full object-cover " />
                </div>
                <div
                    className="col-start-2 row-start-3 row-span-2 md:col-start-2 md:row-start-3 md:col-span-1 md:row-span-2 bg-gray-300 rounded-md">
                    <img src="/images/christmasDinner.jpg" alt="Car" className="w-full h-full  object-cover" />
                </div>
                <div
                    className="col-start-3 row-start-1 row-span-3 md:col-start-3 md:row-start-1 md:col-span-1 md:row-span-3 bg-gray-300 rounded-md ">
                    <img src="/images/back.png" alt="Car" className="w-full h-full object-cover " />
                </div>
                <div
                    className="col-start-3 row-start-4 row-span-3 md:col-start-3 md:row-start-4 md:col-span-1 md:row-span-3 bg-gray-300 rounded-md ">
                    <img src="/images/card.jpg" alt="Car" className="w-full h-full object-cover " />
                </div>
                <div
                    className="col-start-1 row-start-5 col-span-2 row-span-2 md:col-start-1 md:row-start-5 md:col-span-2 md:row-span-2 bg-gray-300 rounded-md ">
                    <img src="/images/team.png" alt="Car" className="w-full h-full object-cover " />
                </div>

            </div>





            <a
                href="!"
                onClick={handleOpen}
                className="button button--nina  hover:bg-[#252153] text-gray-300 hover:text-white relative block focus:outline-none border-2 border-solid rounded-2xl text-sm text-center font-semibold uppercase tracking-widest overflow-hidden"
                data-text="See The Team"
            >


                <span className="align-middle">S</span>
                <span className="align-middle">e</span>
                <span className="align-middle">e</span>
                <span className="align-middle">&nbsp;</span>
                <span className="align-middle">T</span>
                <span className="align-middle">h</span>
                <span className="align-middle">e</span>
                <span className="align-middle">&nbsp;</span>
                <span className="align-middle">T</span>
                <span className="align-middle">e</span>
                <span className="align-middle">a</span>
                <span className="align-middle">m</span>
            </a>

            <TeamModal
                isOpen={isTeamOpen}
                onClose={() => setIsTeamOpen(false)}
            />
        </section>
    );
};

export default TheTeam;
